import { useQuery } from '@tanstack/react-query';
import { CompanyService } from './CompanyService';

export function useCompanyPublicData({ search }: { search?: string }) {
    const { data, isLoading, isFetching, error } = useQuery(
        ['CompanyPublicData', search],
        async () => {
            const service = new CompanyService();

            const company = await service.getCompanyInformation(search!);

            return company;
        },
        {
            enabled: !!search,
            staleTime: Infinity,
            cacheTime: Infinity,
        }
    );

    return {
        data,
        isLoading: isLoading || isFetching,
        error,
    };
}
